import type { SparksProactiveQuestion } from '@/components/composite/SparksAgent/types';

/** Prefix for optimistic user rows before POST succeeds; `user-` suffix rows are post-success placeholders. */
export const OPTIMISTIC_ID_PREFIX = 'sparks-optimistic-message-';

/** Page size for GET / AI conversation messages (SWR infinite + optimistic cache). */
export const AI_CONVERSATION_MESSAGES_PAGE_SIZE = 30;

export const SPARKS_GLOBAL_SOCIAL_SELECTION_ROUTE_PREFIXES: readonly string[] = [
    '/analytics',
    '/content',
    '/publishing',
    '/listening',
    '/conversations',
    '/media',
    '/inspiration',
    '/reports',
    '/discover',
    '/groups'
];

export const DEFAULT_HEIGHT = 500;
export const MIN_HEIGHT = DEFAULT_HEIGHT;
export const CONTAINER_WIDTH = 450;
/** Reserved space from viewport bottom so max height stops at the app corner (bottom-4 + extra for corner alignment). */
export const BOTTOM_GAP = 32;
/** Top navbar height (px). Container max height is limited so it does not overlap the navbar. */
export const TOP_NAVBAR_HEIGHT = 56;
export const GAP_BELOW_NAVBAR = 4;
export const STORAGE_KEY = 'sparks-container-height';
export const STORAGE_KEY_OPEN = 'sparks-container-open';

export const QUESTION_POOL: readonly SparksProactiveQuestion[] = [
    // Core Period Comparison (3)
    {
        id: 'period_changed',
        intent: 'core_period_comparison',
        translationKey: 'question_period_changed'
    },
    {
        id: 'metrics_changed',
        intent: 'core_period_comparison',
        translationKey: 'question_metrics_changed'
    },
    {
        id: 'performance_trend',
        intent: 'core_period_comparison',
        translationKey: 'question_performance_trend'
    },
    // Focus & Prioritization (3)
    {
        id: 'metrics_focus',
        intent: 'focus_prioritization',
        translationKey: 'question_metrics_focus'
    },
    { id: 'standout', intent: 'focus_prioritization', translationKey: 'question_standout' },
    {
        id: 'biggest_impact',
        intent: 'focus_prioritization',
        translationKey: 'question_biggest_impact'
    },
    // Stability & Consistency (2)
    { id: 'stability', intent: 'stability_consistency', translationKey: 'question_stability' },
    {
        id: 'posting_frequency',
        intent: 'stability_consistency',
        translationKey: 'question_posting_frequency'
    },
    // Audience & Growth (2)
    {
        id: 'audience_growth',
        intent: 'audience_growth',
        translationKey: 'question_audience_growth'
    },
    { id: 'interactions', intent: 'audience_growth', translationKey: 'question_interactions' }
];

